import { render, staticRenderFns } from "./supplierTypeManageList.vue?vue&type=template&id=68a3c5d5&scoped=true"
import script from "./supplierTypeManageList.vue?vue&type=script&lang=js"
export * from "./supplierTypeManageList.vue?vue&type=script&lang=js"
import style0 from "./supplierTypeManageList.vue?vue&type=style&index=0&id=68a3c5d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a3c5d5",
  null
  
)

export default component.exports